import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateReportSearch, updateStartDateForReporting, updateEndDateForReporting } from '../../../../actions/report';
import moment from 'moment';
import ReportTile from '../report-tile/content';
import RightPanelOrTopPanel from './rightPanelOrTopPanel';
import { Loader, Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';
import GenerateReport from './centerPanelGenerateReport.js';
// TODO: fix the issue that the report page cannot render on localhost, should be check if the future format of import works
import DatePicker from 'react-datepicker/dist/react-datepicker.js';
import { reportInitialState } from 'store/initialState';

export default function ViewAllReportsCenterPanel(props) {
  const dispatch = useDispatch();
  const [startDate, setStartDate] = useState(props.startDate && moment(props.startDate));
  const [endDate, setEndDate] = useState(props.endDate && moment(props.endDate));
  const [maxDateOfToField, setMaxDateOfToField] = useState(moment().utcOffset(props.timezone).endOf('year')); // User is NOT allowed to select any dates for next year, because it's in the future
  const [minDateOfFromField, setMinDateOfFromField] = useState(moment('02-01-2010', 'DD-MM-YYYY')); // 02-01-2010 is the earliest date that user can get data for report
  const _second_calendar = useRef(null);

  const handleChangeStartDate = (date) => {
    if (date > endDate) {
      setStartDate(date);
      // setEndDate(date);
      dispatch(updateStartDateForReporting(date));
      dispatch(updateEndDateForReporting(date));
    } else {
      setStartDate(date);
      dispatch(updateStartDateForReporting(date));
    }

    setTimeout(function () {
      _second_calendar.current.setOpen(true);
    }, 100);
  };

  const handleChangeEndDate = (date) => {
    setEndDate(date);
  };

  useEffect(() => {
    dispatch(updateEndDateForReporting(endDate));
    if (startDate && endDate) {
      dispatch(
        updateReportSearch(
          props.minConsultationDurValue,
          props.minMeetingDurValue,
          props.timezone,
          startDate.format('YYYY-MM-DD'),
          endDate.format('YYYY-MM-DD')
        )
      );
    }
  }, [endDate]);

  const generateCSVUrl = (CSVname, hasMinConDur, hasMinMeetingDur) => {
    let CSVUrl = '';
    if (CSVname && !!startDate && !!startDate) {
      let startDateFormat = startDate.format('YYYY-MM-DD');
      let endDateFormat = endDate.format('YYYY-MM-DD');
      if (hasMinConDur == true && hasMinMeetingDur == false) {
        CSVUrl =
          window.APP.CONFIGURATION.VCCAPI +
          `report/${CSVname}/${props.minConsultationDurValue}/${startDateFormat}/${endDateFormat}`;
      }
      if (hasMinConDur == false && hasMinMeetingDur == true) {
        CSVUrl =
          window.APP.CONFIGURATION.VCCAPI +
          `report/${CSVname}/${props.minMeetingDurValue}/${startDateFormat}/${endDateFormat}`;
      }
      if (hasMinConDur == true && hasMinMeetingDur == true) {
        CSVUrl =
          window.APP.CONFIGURATION.VCCAPI +
          `report/${CSVname}/${props.minConsultationDurValue}/${props.minMeetingDurValue}/${startDateFormat}/${endDateFormat}`;
      }
      if (hasMinConDur == false && hasMinMeetingDur == false) {
        CSVUrl = window.APP.CONFIGURATION.VCCAPI + `report/${CSVname}/${startDateFormat}/${endDateFormat}`;
      }
    }
    return CSVUrl;
  };

  // let totalPeopleWaiting = 0;
  // let totalIdleCalls = 0;
  // let longestWait = 0;
  // let totalPeopleBeingAttended = 0;
  // let totalWaitingAreasOccupied = 0;
  // let allThePeopleInWaitingAreas = 0;

  const renderWaitingAreas = (gray) => {
    // opaqued means transparent tiles like loading
    let opaqued = gray;
    let reports = props.reports;
    let isAdmin = props.isAdmin;

    return Object.entries(reports).map(([key, value], i) => {
      if (value) {
        let renderedTile = '';
        let colourTheme = '';
        let canDownload = false;
        let entries = [];
        let isShow = true;
        let csvURL = '';
        switch (key) {
          case 'orgnisationalUnits':
            renderedTile = APP.LANGUAGE.MainReport.OrgUnitsTitle;
            colourTheme = 'color-organisational-unit-bg-highlight';
            canDownload = true;
            entries = [
              [APP.LANGUAGE.MainReport.TotalInReport, false, props.reports.orgnisationalUnits.total],
              [APP.LANGUAGE.MainReport.WithActivity, true, props.reports.orgnisationalUnits.active],
              [APP.LANGUAGE.MainReport.NewInReport, false, props.reports.orgnisationalUnits.new],
            ];
            csvURL = generateCSVUrl('orgnisationalunitcsv', true, true);
            break;
          case 'waitingAreas':
            renderedTile = APP.LANGUAGE.MainReport.WaitingAreasTitle;
            colourTheme = 'color-waiting-area-bg-highlight';
            canDownload = true;
            entries = [
              [APP.LANGUAGE.MainReport.TotalInReport, false, props.reports.waitingAreas.total],
              [APP.LANGUAGE.MainReport.UsedForConsultations, true, props.reports.waitingAreas.active],
              [APP.LANGUAGE.MainReport.NewInReport, false, props.reports.waitingAreas.new],
            ];
            csvURL = generateCSVUrl('waitingareacsv', true, false);
            break;
          case 'consultants':
            renderedTile = APP.LANGUAGE.MainReport.ConsultantsTitle;
            colourTheme = 'color-waiting-area-bg-highlight';
            canDownload = true;
            entries = [
              [APP.LANGUAGE.MainReport.TotalInReport, false, props.reports.consultants.total],
              [APP.LANGUAGE.MainReport.ParInConsultations, true, props.reports.consultants.active],
              [APP.LANGUAGE.MainReport.NewInReport, false, props.reports.consultants.new],
            ];
            csvURL = generateCSVUrl('consultantcsv', true, false);
            break;
          case 'consultations':
            renderedTile = APP.LANGUAGE.MainReport.ConsultationsTitle;
            colourTheme = 'color-waiting-area-bg-highlight';
            canDownload = true;
            entries = [
              [APP.LANGUAGE.MainReport.TotalInReport, true, props.reports.consultations.total],
              [APP.LANGUAGE.MainReport.Consultants, true, props.reports.consultations.activeConsultants],
              [APP.LANGUAGE.MainReport.Callers, true, props.reports.consultations.callers],
              [APP.LANGUAGE.MainReport.ConsultationHours, true, props.reports.consultations.hours],
            ];
            csvURL = generateCSVUrl('consultationhistorycsv', false, false);
            break;
          case 'meetingRooms':
            renderedTile = APP.LANGUAGE.MainReport.MeetingRoomsTitle;
            colourTheme = 'color-meeting-room-bg-highlight';
            canDownload = true;
            entries = [
              [APP.LANGUAGE.MainReport.TotalInReport, false, props.reports.meetingRooms.total],
              [APP.LANGUAGE.MainReport.UsedForMeetings, true, props.reports.meetingRooms.active],
              [APP.LANGUAGE.MainReport.NewInReport, false, props.reports.meetingRooms.new],
            ];
            csvURL = generateCSVUrl('meetingroomcsv', false, true);
            break;
          case 'meetingRoomMembers':
            renderedTile = APP.LANGUAGE.MainReport.MeetingRoomMembersTitle;
            colourTheme = 'color-meeting-room-bg-highlight';
            canDownload = true;
            entries = [
              [APP.LANGUAGE.MainReport.TotalInReport, false, props.reports.meetingRoomMembers.total],
              [APP.LANGUAGE.MainReport.ParInMeetings, true, props.reports.meetingRoomMembers.active],
              [APP.LANGUAGE.MainReport.NewInReport, false, props.reports.meetingRoomMembers.new],
            ];
            csvURL = generateCSVUrl('meetingroomusercsv', false, true);
            break;
          case 'meetings':
            renderedTile = APP.LANGUAGE.MainReport.MeetingsTitle;
            colourTheme = 'color-meeting-room-bg-highlight';
            canDownload = false;
            entries = [
              [APP.LANGUAGE.MainReport.TotalInReport, true, props.reports.meetings.total],
              [APP.LANGUAGE.MainReport.Members, true, props.reports.meetings.meetingRoomUsers],
              [APP.LANGUAGE.MainReport.Guests, true, props.reports.meetings.guests],
              [APP.LANGUAGE.MainReport.MeetingHours, true, props.reports.meetings.hours],
            ];
            csvURL = generateCSVUrl();
            break;
          case 'platformAccounts':
            renderedTile = APP.LANGUAGE.MainReport.PlatformAccountsTtile;
            colourTheme = 'color-mid-grey-bg';
            canDownload = true;
            entries = [
              [APP.LANGUAGE.MainReport.TotalInReport, false, props.reports.platformAccounts.total],
              [APP.LANGUAGE.MainReport.SignedIn, false, props.reports.platformAccounts.active],
              [APP.LANGUAGE.MainReport.NewInReport, false, props.reports.platformAccounts.new],
            ];
            csvURL = generateCSVUrl('platformaccountcsv', false, false);
            break;
          case 'generalActivity':
            renderedTile = APP.LANGUAGE.MainReport.GeneralAcitivity;
            colourTheme = 'color-mid-grey-bg';
            canDownload = false;
            entries = [
              [APP.LANGUAGE.MainReport.Users, false, props.reports.generalActivity.users],
              [APP.LANGUAGE.MainReport.Calls, false, props.reports.generalActivity.calls],
              [APP.LANGUAGE.MainReport.CallMinutes, false, props.reports.generalActivity.callMinutes],
              [APP.LANGUAGE.MainReport.Encounters, false, props.reports.generalActivity.encounters],
            ];
            csvURL = generateCSVUrl();
            break;
          default:
            renderedTile = '';
            colourTheme = 'color-waiting-area-bg-highlight';
            canDownload = false;
            isShow = false;
            entries = [
              [APP.LANGUAGE.MainReport.TotalInReport, false, null],
              [APP.LANGUAGE.MainReport.UsedForConsultations, false, null],
              [APP.LANGUAGE.MainReport.NewInReport, false, null],
            ];
            csvURL = generateCSVUrl();
            break;
        }
        return (
          <ReportTile
            key={i}
            opaqued={opaqued}
            colourTheme={colourTheme}
            renderedTile={renderedTile}
            entries={entries}
            value={value}
            canDownload={canDownload}
            isShow={isShow}
            csvUrl={csvURL}
          />
        );
      } else {
        return '';
      }
    });
  };

  let areThereWaitingAreasAndWeArentFetching = !props.fetchingReports;
  const renderInQuickViewMode = props.noHeader;
  let reportTilesHtml = '';

  if (!renderInQuickViewMode && areThereWaitingAreasAndWeArentFetching) {
    reportTilesHtml = renderWaitingAreas(false);
  }

  // If it is fectching WA - loading, then rendering this part.
  if (props.fetchingReports) {
    reportTilesHtml = (
      <div className="ui report-tile shape pdrs mrbm invisible-to-full">
        <div className="sides">
          <div className="ui active inverted dimmer ">
            <Loader size="large" />
          </div>
          <div className="active side">
            <div className="ui card border-radius-null borderless main-report-card">
              <div className="content main-report-statistics" data-is-filtered={false}>
                <span className="report-title-bar color-gray-bg">
                  <div className="statistic mrbm">
                    <div className="color-gray pdrxs pdlxs">Header</div>
                  </div>
                </span>
                {/* TODO: Once the new naming is merged, please change the breakpoint names to be the new ones */}
                <Container fluid as={Media} greaterThanOrEqual="tablet">
                  <div className="central-block-container hide-on-small-devices mrtl">
                    <div className="mrrxl mrlxl mrbm">
                      <div className="color-gray color-gray-bg value">
                        <div className="val-num mrbm">0</div>
                      </div>
                      <div className="color-gray color-gray-bg">TEST</div>
                    </div>
                    <div className="mrrxl mrlxl mrbl">
                      <div className="color-gray color-gray-bg value">
                        <div className="val-num mrbm">0</div>
                      </div>
                      <div className="color-gray color-gray-bg">TEST</div>
                    </div>
                    <div className="mrrxl mrlxl">
                      <div className="color-gray color-gray-bg value">
                        <div className="val-num mrbm">0</div>
                      </div>
                      <div className="color-gray color-gray-bg">TEST</div>
                    </div>
                  </div>
                </Container>
                <Container fluid as={Media} at="mobile">
                  <div className="row-figures mrbxxs mrtl">
                    <span className="color-gray-bg value">
                      <div className="color-gray color-gray-bg mrrl mrll value">
                        <div className="val-num mrbm">000000</div>
                      </div>
                      <div className="color-gray color-gray-bg mrrl mrll value">
                        <div className="val-num mrbm">000000</div>
                      </div>
                      <div className="color-gray color-gray-bg mrrl mrll value">
                        <div className="val-num mrbm">000000</div>
                      </div>
                    </span>
                  </div>
                </Container>
                <div className="mid-bottom-info-container report color-gray-bg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="ui  aligned padded grid filter-bar">
        <div
          className="row flexible  color-primary pdtnull pdbnull mrbm header-row pdlnull "
          data-show={!props.noHeader}
        >
          <div className="ui transparent large fluid icon input color-white color-primary reports-filter">
            <div className=" ui transparent  fluid icon input color-white column color-white left-text reports-filter-inner-container">
              <div
                className="ui  icon input color-white color-mid-grey-bg center-flex start date-picker-bar"
                style={{
                  pointerEvents: props.fetchingReports ? 'none' : 'auto',
                }}
              >
                <i className="calendar link icon mrrs fl" />
                {props.hasMoreThanOneOrg ? (
                  <DatePicker
                    dateFormat={APP.LANGUAGE.MainReport.DateFormat}
                    selected={(props.startDate && moment(props.startDate)) || null}
                    readOnly
                    selectsStart
                    disabledKeyboardNavigation={true}
                    startDate={startDate}
                    locale={navigator.languages[0]}
                    minDate={minDateOfFromField}
                    maxDate={moment()}
                    onChange={handleChangeStartDate}
                    // onBlur={handleStartDateBlur}
                    onSelect={handleChangeStartDate}
                    className={
                      props.fetchingReports
                        ? 'color-placeholder bg-transparent fr start-date'
                        : 'color-white bg-transparent fr start-date'
                    }
                    showMonthDropdown
                    useShortMonthInDropdown
                    showYearDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={10}
                    placeholderText={props.isOnMobileOrTablet ? 'Start Date' : 'Select Start Date'}
                  />
                ) : (
                  <DatePicker
                    dateFormat={APP.LANGUAGE.MainReport.DateFormat}
                    selected={startDate}
                    readOnly
                    selectsStart
                    disabledKeyboardNavigation={true}
                    startDate={startDate}
                    locale={navigator.languages[0]}
                    minDate={minDateOfFromField}
                    maxDate={moment()}
                    onChange={handleChangeStartDate}
                    // onBlur={handleStartDateBlur}
                    onSelect={handleChangeStartDate}
                    className={
                      props.fetchingReports
                        ? 'color-placeholder bg-transparent fr start-date'
                        : 'color-white bg-transparent fr start-date'
                    }
                    showMonthDropdown
                    useShortMonthInDropdown
                    showYearDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={10}
                  />
                )}
              </div>
              <span className="mrrs mrls mrtxs to-text">{APP.LANGUAGE.MainReport.RangeInfoText}</span>
              <div
                className="ui icon input color-white color-mid-grey-bg center-flex end date-picker-bar"
                style={{
                  pointerEvents: props.fetchingReports ? 'none' : 'auto',
                }}
              >
                <i className="calendar link icon mrrs fl" />
                {props.hasMoreThanOneOrg ? (
                  <DatePicker
                    dateFormat={APP.LANGUAGE.MainReport.DateFormat}
                    selected={(props.endDate && moment(props.endDate)) || null}
                    selectsEnd
                    readOnly
                    maxDate={maxDateOfToField}
                    startDate={startDate}
                    minDate={startDate}
                    locale={navigator.languages[0]}
                    endDate={endDate}
                    // onChangeRaw={onChangeRaw}
                    // onBlur={handleEndDateBlur}
                    onSelect={handleChangeEndDate}
                    startOpen={false}
                    className={
                      props.fetchingReports
                        ? 'color-placeholder bg-transparent fr end-date'
                        : 'color-white bg-transparent fr end-date'
                    }
                    showMonthDropdown
                    useShortMonthInDropdown
                    showYearDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={10}
                    ref={_second_calendar}
                    placeholderText={props.isOnMobileOrTablet ? 'End Date' : 'Select End Date'}
                  />
                ) : (
                  <DatePicker
                    dateFormat={APP.LANGUAGE.MainReport.DateFormat}
                    selected={endDate}
                    selectsEnd
                    readOnly
                    maxDate={maxDateOfToField}
                    startDate={startDate}
                    minDate={startDate}
                    locale={navigator.languages[0]}
                    endDate={endDate}
                    // onChangeRaw={onChangeRaw}
                    // onBlur={handleEndDateBlur}
                    onSelect={handleChangeEndDate}
                    startOpen={false}
                    className={
                      props.fetchingReports
                        ? 'color-placeholder bg-transparent fr end-date'
                        : 'color-white bg-transparent fr end-date'
                    }
                    showMonthDropdown
                    useShortMonthInDropdown
                    showYearDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={10}
                    ref={_second_calendar}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={props.isOnMobileOrTablet ? 'shapes-wrapper report-page mrlm mrrm' : 'shapes-wrapper report-page'}>
        <div className="shape-columns" data-rendered-as-preview={props.noHeader}>
          <div className="top-rail-with-left-and-right-content">
            <RightPanelOrTopPanel
              minConsultationDurValue={props.minConsultationDurValue}
              minMeetingDurValue={props.minMeetingDurValue}
              fetchingReports={props.fetchingReports}
              hideDataOutdateWarning={props.hideDataOutdateWarning}
            />
            <div className="mrbm" />
          </div>
          {props.hasMoreThanOneOrg &&
          (props.startDate == null ||
            props.endDate == null ||
            (!props.fetchingReports && props.reports == reportInitialState.reports)) ? (
            <GenerateReport />
          ) : (
            reportTilesHtml
          )}
        </div>
      </div>
    </div>
  );
}
